import { useFormik } from "formik";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { forgot_password, ForgotPassoword } from "../actions/auth";
import Input from "../form-components/Input";
import * as Yup from "yup";
import { HomeWrapper } from "./Login";
import { useEffect } from "react";
import { toast } from "react-toastify";

const ResetPasswordSchema = Yup.object().shape({
  email: Yup.string().required("Email is required"),
});
const ResetForm = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const forgotRes = useSelector((state) => state?.auth?.forgot_password);

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: ResetPasswordSchema,
    onSubmit: (values) => {
      dispatch(forgot_password(values));
    },
  });

  useEffect(() => {
    if (forgotRes && forgotRes.success) {
      toast.success("Reset password email sent success.");
      dispatch({ type: ForgotPassoword.RESET });
      history.push("/thank-you", {
        email: formik.values.email,
      });
      formik.resetForm();
    }

    if (forgotRes && forgotRes.success === false) {
      toast.error(forgotRes?.data?.message);
      dispatch({ type: ForgotPassoword.RESET });
    }
    // eslint-disable-next-line
  }, [forgotRes]);
  return (
    <HomeWrapper>
      <form className="flex-center" onSubmit={formik.handleSubmit}>
        <div>
          <div className="head-sec">
            <h3 className="text-heading">Reset your password</h3>
            <span className="text-sub-heading mt1 mb1 w60">
              We will send you an email with a link to reset your password
            </span>
          </div>
          <Input placeholder={"Enter email"} name="email" formik={formik} type="email" />
          <div className="v-center mt2">
            <button className="primary-btn mr1" disabled={forgotRes?.loading}>
              {forgotRes?.loading ? "Sending email..." : "Reset Password"}
            </button>
            <span
              className="p-link "
              onClick={() => {
                history.push("/");
              }}
            >
              Back to login
            </span>
          </div>
        </div>
      </form>
    </HomeWrapper>
  );
};

export default ResetForm;
